/**
 * The stage badge on a reservations-tab row. Extracted from `ReservationsPanel`
 * (BON-472) so that file declares one component.
 */
import type { ReservationRow } from '../../api/reservations';

import { stageBadge, type ReservationTone } from './reservationFormat';

/** This page's paint for a stage tone. The tone itself is shared with workshop
 *  detail (BON-478), which renders the same stages through `StatusPill`. */
const TONE_CLASS: Record<ReservationTone, string> = {
  watch: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  open: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  active: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  'at-risk': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  soft: 'bg-stone-100 text-stone-700 dark:bg-stone-800 dark:text-stone-300',
};

export function ReservationStagePill({ stage }: { stage: ReservationRow['stage'] }) {
  const badge = stageBadge(stage);
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${TONE_CLASS[badge.tone]}`}
    >
      {badge.label}
    </span>
  );
}
